module.exports = __webpack_public_path__ + "img/user-shield-regular.ca0090c4.svg";